import React, { useEffect, useState } from 'react';
import { InputItem, Button, Picker, Toast } from 'antd-mobile';
import TitleComponent from '../comm/title/title';
import SubmitComponent from '../submit/submit';
import { ApiCore } from '../../../api';
import styles from '../createAccount/createAccount.module.scss';

const api = new ApiCore();
// 暂存数据
let temporaryData: any = {}

function CreateAccount(props: any) {

    // 医院
    const [hospitalName, setHospitalName] = useState<any>('');
    // 科室
    const [officeName, setOfficeName] = useState<any>('');
    // 职称
    const [positionName, setPositionName] = useState<any>('');
    // 姓名
    const [username, setUsername] = useState<any>('');
    const [checked, setChecked] = useState<any>(null);
    const [authorList, setAuthorList] = useState<any>([]);
    const [hasError, setHasError] = useState<any>(false);

    let Info: any = []
    let authCheckedInfo: any = []
    let authorizationInfo = sessionStorage.getItem('authorizationInfo')
    let authChecked = sessionStorage.getItem('authChecked')
    if (authorizationInfo) {
        Info = JSON.parse(authorizationInfo)
    }
    if (authChecked) {
        authCheckedInfo = JSON.parse(authChecked)
    }
    

    useEffect(() => {
        //设置网页title
        document.title = '详情';

        if (props.location.params) {
            setChecked(props.location.params.checked)
            setAuthorList(props.location.params.data)
            
            // 同意授权
            if (props.location.params.checked) {
                
                // 用户输入信息
                for (let key in Info) {
                    
                    if (authCheckedInfo.includes(key)) {
                        if (Info[key] == '' || !Info[key] || Info[key] == null) {
                            Info[key] = temporaryData[key]
                        }
                    } else {
                        if (temporaryData[key] == Info[key]) {
                            Info[key] = ''
                        }
                    }
                }

                setHospitalName(Info.hospital)
                setOfficeName(Info.department)
                setPositionName(Info.title)
                setUsername(Info.name)
                sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
            } else {
                
                // 不同意授权
                if (props.location.params.data.length == 0) {
                   
                    for (let key in Info) {
                    
                        if (authCheckedInfo.includes(key)) {
                            if (Info[key] == '' || !Info[key] || Info[key] == null) {
                                Info[key] = temporaryData[key]
                            }
                        } else {
                            if (temporaryData[key] == Info[key]) {
                                Info[key] = ''
                            }
                        }
                    }
    
                    setHospitalName(Info.hospital)
                    setOfficeName(Info.department)
                    setPositionName(Info.title)
                    setUsername(Info.name)
                    sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
                } else {
                    let data = props.location.params.data

                    for (let key in Info) {
                        if (!data.includes(key)) {
                            Info[key] = ''
                        } else {
                            Info[key] = temporaryData[key]
                        }
                    }

                    setHospitalName(Info.hospital)
                    setOfficeName(Info.department)
                    setPositionName(Info.title)
                    setUsername(Info.name)
                    sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
                }
            }
        } else {
            supplementData()
        }
    }, [])

    // 查询EDC账号医生信息
    const supplementData = () => {
        getAccountInfo()
    }

    const getAccountInfo = () => {
        api.GetAccountInfo().then(res => {
            if (res.code == '0') {
                temporaryData = res.data

                setUsername(res.data.name)
                setHospitalName(res.data.hospital)
                setOfficeName(res.data.department)
                setPositionName(res.data.title)

                let obj = {
                    name: res.data.name,
                    hospital: res.data.hospital,
                    department: res.data.department,
                    title: res.data.title
                }
                sessionStorage.setItem('authorizationInfo', JSON.stringify(obj))
            }
            else {
                Toast.fail(res.message)
            }
        })
    }

    // 医院
    const onHospitalName = (value: any) => {
        setHospitalName(value)
        Info['hospital'] = value
        sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
    }

    // 科室
    const onOfficeName = (value: any) => {
        setOfficeName(value)
        Info['department'] = value
        sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
    }
    // 职称
    const onPositionName = (value: any) => {
        setPositionName(value)
        Info['title'] = value
        sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
    }
    // 姓名
    const onUserName = (value: any) => {
        let errorExtra = document.querySelector('.am-input-error-extra');

        if (value == '' || value == null) {
            // Toast.fail('姓名不能为空')
            setHasError(true)
        } else {
            setHasError(false)
        }

        setUsername(value)
        Info['name'] = value
        sessionStorage.setItem('authorizationInfo', JSON.stringify(Info))
    }

    // 数据
    const dataList = [
        { key: 'InputItem', label: '姓名', type: 'text', placeholder: '请输入您的真实姓名（必填）', maxLength: 50, value: username, onChange: (v: any) => onUserName(v) },
        { key: 'InputItem', label: '所在医疗机构', type: 'text', placeholder: '请填写您所在医疗机构', maxLength: 50, value: hospitalName, onChange: (v: any) => onHospitalName(v) },
        { key: 'InputItem', label: '所在科室', type: 'text', placeholder: '请填写您所在科室', maxLength: 50, value: officeName, onChange: (v: any) => onOfficeName(v) },
        { key: 'InputItem', label: '职称', type: 'text', placeholder: '请填写您的职称', maxLength: 50, value: positionName, onChange: (v: any) => onPositionName(v) }
    ]

    return (
        <div className={'content_wrap'}>
            <div className={styles.createAccount}>
                <TitleComponent title='补充账号信息' subTitle={<>已为您通过手机号注册账号，<br />请补充以下个人信息（除姓名外其他皆为选填项）</>} />
                {
                    dataList.map((item: any, index: any) => (
                        <div className={styles.InputItemContent} key={index}>

                            <label className={'findlabel'}><span style={{ color: 'red' }} hidden={item.label !== '姓名'}>* </span>{item.label}</label>
                            <InputItem
                                type={item.type}
                                placeholder={item.placeholder}
                                maxLength={item.maxLength}
                                value={item.value}
                                onChange={item.onChange}
                                checked={props.location.params ? props.location.params.checked : checked}
                                error={item.label == '姓名' && hasError}
                                clear
                            />
                        </div>

                    ))
                }

            </div>

            <SubmitComponent
                text={'绑定'}
                type={'createaccount'}
                {...props}
                username={username}
                hospital={hospitalName}
                office={officeName}
                position={positionName}
                checked={props.location.params ? props.location.params.checked : checked}
                authorList={authorList}
            />
        </div>
    )

}

export default CreateAccount;